import { localeCompareAlphanumeric } from '@/utils/base'
import store from '@/store/index.js'
import { lengthGroupSorter } from '@/components/account/account-scaling/length-groups/LengthGroups.js'
import { diameterGroupSorter } from '@/components/account/account-scaling/diameter-groups/DiameterGroups.js'

export function speciesGroupSorter (speciesGroupA, speciesGroupB) {
  return localeCompareAlphanumeric(speciesGroupA.label, speciesGroupB.label)
}

export function sortSpeciesWithinGroups (speciesGroups) {
  if (speciesGroups) {
    speciesGroups.forEach(speciesGroup => {
      if (speciesGroup.species) {
        speciesGroup.species.sort(speciesSorter)
      }
    })
  }
}

export function sortLengthGroupsWithinSpeciesGroups (speciesGroups) {
  if (speciesGroups) {
    speciesGroups.forEach(speciesGroup => {
      if (speciesGroup.lengthGroups) {
        speciesGroup.lengthGroups.sort(lengthGroupSorter)
      }
    })
  }
}

export function sortDiameterGroupsWithinSpeciesGroups (speciesGroups) {
  if (speciesGroups) {
    speciesGroups.forEach(speciesGroup => {
      if (speciesGroup.diameterGroups) {
        speciesGroup.diameterGroups.sort(diameterGroupSorter)
      }
    })
  }
}

export function speciesSorter (speciesA, speciesB) {
  return localeCompareAlphanumeric(speciesA.commonName, speciesB.commonName)
}

export function getSpeciesGroupByLabel (label) {
  const groups = store.getters['account-scaling/accountSpeciesGroups']
  return groups.find(group => group.label === label)
}

export function getSpeciesGroupTooltip (rateSheetLine, accountId, speciesGroups = store.getters['account-scaling/accountSpeciesGroups']) {
  const speciesGroup = speciesGroups
    .find(sg => sg.label === rateSheetLine.speciesGroup)
  if (!speciesGroup || speciesGroup.accountId !== accountId) return undefined
  return speciesGroup.species.map(s => s.commonName).join(', ')
}
